import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import React, { useState } from 'react';
import FuelingGraphSection from './FuelingGraphSection';
import { useSelector } from 'react-redux';
import IAppState from 'infrastructure/store/IAppState';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import { endOfMonth } from 'date-fns';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import FuelingSummaryDetailListSection from './FuelingSummaryDetailListSection';
import { FuelingTransactionViewType } from '../enums/fuelingTransactionViewType';
import { useTranslation } from 'react-i18next';
import FuelingSummaryDetailTabs from '../components/FuelingSummaryDetailTabs';

type Props = {
  year: number;
  month: number;
  commodityDetail: CommodityDetail;
}

const FuelingSummaryDetailSection = ({ year, month, commodityDetail }: Props) => {
  // transaltions
  const tLabels = useTranslation("fueling\\fueling").t;

  // state
  const [hasFuelingData, setHasFuelingData] = useState(false);
  const [selectedViewType, setSelectedViewType] = useState<FuelingTransactionViewType>("FuelingCard");

  // store
  const customer = useSelector<IAppState, CustomerState>( (store) => store.customer).customer;

  // render
  return (
    <>
      <FuelingGraphSection 
        entityType="Customer"
        entityId={customer.customerId!}
        commodityDetail={commodityDetail}
        from={new Date(year, month - 1, 1)}
        to={endOfMonth(new Date(year, month - 1, 1))}
        quotationType="Day"
        setHasFuelingHistory={setHasFuelingData}
      />
      <RenderWrapper isVisible={() => hasFuelingData}>
        <h4 className="mt-4 mb-3 text-muted">
          {tLabels(`fuelingSummaryDetailSection.summaryTitle.${commodityDetail}`)}
        </h4>
        <div className="mb-4">
          <FuelingSummaryDetailTabs 
            selectedViewType={selectedViewType}
            setSelectedViewType={setSelectedViewType}
          />
        </div>
        <FuelingSummaryDetailListSection 
          year={year}
          month={month}
          commodityDetail={commodityDetail}
          viewType={selectedViewType}
        />
      </RenderWrapper>
    </>
  )
}

export default FuelingSummaryDetailSection;